export default {
    'query.queryCard.h1':'Глобальна платформа логістики',
    'query.queryCard.p':'система запитів з логістики, повна логістика та логістика, що забезпечує чіткий стандартний стан траєкторії, повну та точну інформацію про траєкторію, точність запитів становить 99%.',
    'query.queryCard.placeholder':'введіть номер',
    'query.queryCard.submit':'запит',
    'query.stepsCard.item01.title':'точне стеження',
    'query.stepsCard.item01.desc':'запит локалізації у реальному часі',
    'query.stepsCard.item02.title':'Ефективна митниця',
    'query.stepsCard.item02.desc':'Багатопортове митне оформлення надзвичайно ефективне',
    'query.stepsCard.item03.title':'Ексклюзивний сервіс',
    'query.stepsCard.item03.desc':'Пріоритет на складі, топовий постачальник логістичних послуг',
    'query.stepsCard.item04.title':'Гарантія якості',
    'query.stepsCard.item04.desc':'ТІЛЬКИ звичайні товари, безпечні та стабільні',
    'query.stepsCard.item05.title':'Топова логістика',
    'query.stepsCard.item05.desc':'Найкращий постачальник логістичних послуг, більш комфортний для кінцевої доставки',
}